// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".offer-title[data-v-2633bd75]{font-size:34px;font-weight:600}.offer-subtitle[data-v-2633bd75]{font-size:22px;margin:40px 0 0}.button-wrapper[data-v-2633bd75]{margin-top:30px}.button-wrapper button[data-v-2633bd75]{width:100%}@media (max-width:767px){.button-wrapper button[data-v-2633bd75]{margin-bottom:10px}}.ui-radio__label-text[data-v-2633bd75]{font-size:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
